import styled from 'styled-components';

export const CardWrapper = styled.div(({ theme }) => ({
  '.StripeElement': {
    padding: '8px',
    borderWidth: '1px',
    borderStyle: 'solid',
    borderColor: theme.colors.neutral['200'],
    borderRadius: theme.radii.medium,
    boxShadow: '0px 1px 2px rgba(55, 65, 81, 0.08)',

    '&:hover': {
      borderColor: theme.colors.neutral['400'],
      boxShadow: '0px 1px 2px rgba(55, 65, 81, 0.06), 0px 1px 3px rgba(55, 65, 81, 0.1)',
    },

    '&--invalid': {
      color: theme.colors.error['500'],
      borderColor: theme.colors.error['500'],
    },
  },
}));
